import useLocalStorage from "react-use-localstorage";

export default function buildUseLocalStorageWithPrefix(prefix: string) {
  function useLocalStorageWithPrefix(key:string, defaultValue?: string){
    return useLocalStorage(`${prefix}.${key}`, defaultValue);
  }

  return useLocalStorageWithPrefix;
}